export const Version = '1.1.0';


// WEBPACK FOOTER //
// ./src/utils/config.js